export const ALARM_SOUNDS = [
  { id: 'bell', name: 'Bell', url: '/sounds/bell.mp3' },
  { id: 'digital', name: 'Digital', url: '/sounds/digital.mp3' },
  { id: 'kitchen', name: 'Kitchen Timer', url: '/sounds/kitchen.mp3' },
  { id: 'mechanical', name: 'Mechanical', url: '/sounds/mechanical.mp3' },
  { id: 'electronic', name: 'Electronic', url: '/sounds/electronic.mp3' },
] as const;

export const COLOR_THEMES = [
  { id: 'blue', name: 'Blue', primary: '#3B82F6' },
  { id: 'purple', name: 'Purple', primary: '#8B5CF6' },
  { id: 'green', name: 'Green', primary: '#10B981' },
  { id: 'red', name: 'Red', primary: '#EF4444' },
  { id: 'orange', name: 'Orange', primary: '#F59E0B' },
  { id: 'pink', name: 'Pink', primary: '#EC4899' },
] as const;

export const TICKING_SOUNDS = [
  { id: 'none', name: 'None' },
  { id: 'fast', name: 'Ticking (Fast)', url: '/sounds/ticking-fast.mp3' },
  { id: 'slow', name: 'Ticking (Slow)', url: '/sounds/ticking-slow.mp3' },
  { id: 'white', name: 'White Noise', url: '/sounds/white-noise.mp3' },
  { id: 'brown', name: 'Brown Noise', url: '/sounds/brown-noise.mp3' },
] as const;

export interface TimerSettings {
  workDuration: number;
  shortBreakDuration: number;
  longBreakDuration: number;
  longBreakInterval: number;
  autoStartBreaks: boolean;
  autoStartPomodoros: boolean;
  alarmSound: string;
  alarmVolume: number;
  tickingSound: 'none' | 'fast' | 'slow' | 'white' | 'brown';
  tickingVolume: number;
  colorTheme: string;
  hourFormat: '12' | '24';
  darkModeWhenRunning: boolean;
  smallWindow: boolean;
  notificationsEnabled: boolean;
  reminderInterval: number;
  mobileAlarmEnabled: boolean;
  autoCompleteTask: boolean;
  autoStartNextTask: boolean;
  showGlobalRankings: boolean;
  shareAchievements: boolean;
  completedPomodoros?: number;
}

export const defaultSettings: TimerSettings = {
  workDuration: 60,
  shortBreakDuration: 5,
  longBreakDuration: 15,
  longBreakInterval: 4,
  autoStartBreaks: false,
  autoStartPomodoros: false,
  alarmSound: 'bell',
  alarmVolume: 50,
  tickingSound: 'none',
  tickingVolume: 50,
  colorTheme: 'blue',
  hourFormat: '24',
  darkModeWhenRunning: false,
  smallWindow: false,
  notificationsEnabled: true,
  reminderInterval: 5,
  mobileAlarmEnabled: false,
  autoCompleteTask: true,
  autoStartNextTask: false,
  showGlobalRankings: true,
  shareAchievements: true,
};

export interface TimerState {
  currentSession: number;
  phase: 'work' | 'shortBreak' | 'longBreak';
  timeRemaining: number;
  isActive: boolean;
  settings: TimerSettings;
}

export const initialState: TimerState = {
  currentSession: 0,
  phase: 'work',
  timeRemaining: defaultSettings.workDuration * 60,
  isActive: false,
  settings: defaultSettings,
};